interface TableFilters  {
    showReviewed: boolean;
}

type NumberKeys = "lastLogin";
type StringKeys = "locale" | "oid";
type ObjectKeys = "tableFilters";
type Keys = NumberKeys | StringKeys | ObjectKeys;

function getItem(key: "locale"): "sv" | "en" | undefined;
function getItem(key: StringKeys): string | undefined;
function getItem(key: NumberKeys): number | undefined;
function getItem(key: ObjectKeys): TableFilters | undefined;
function getItem(key: Keys) {
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : undefined;
}

function setItem(key: StringKeys, value: string): void;
function setItem(key: NumberKeys, value: number): void;
function setItem(key: ObjectKeys, value: TableFilters): void;
function setItem(key: Keys, value: unknown) {
    localStorage.setItem(key, JSON.stringify(value));
}

function removeItem(key: Keys) {
    localStorage.removeItem(key);
}

function clear() {
    localStorage.clear();
}

export default {
    getItem,
    setItem,
    removeItem,
    clear,
};
